import { useEffect, useState } from "react";

interface ScrollHintProps {
  className?: string;
}

export const ScrollHint = ({ className = "" }: ScrollHintProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    if (!hasScrolled) setIsVisible(true);

    // Hide hint after scroll
    const handleScroll = () => {
      if (window.scrollY > 100 && !hasScrolled) {
        setHasScrolled(true);
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasScrolled]);

  if (!isVisible) return null;

  return (
    <div className="w-full h-fit bottom-8 fixed z-50 flex flex-col items-center  xl:hidden">
      <div
        className={` pointer-events-none flex items-center flex-col gap-2 animate-bounce ${className}`}
      >
        <div className="text-primary-500 font-bold text-sm bg-white px-4 py-2 rounded-full shadow-lg">
          Swipe up to see more!
        </div>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className="text-primary-500"
        >
          <path
            d="M12 5V19M12 19L5 12M12 19L19 12"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

export const ScrollGradient = () => {
  const [showGradient, setShowGradient] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      const scrolledToBottom = windowHeight + scrollTop >= documentHeight - 100;

      setShowGradient(!scrolledToBottom);
    };

    handleScroll(); // Check initial state
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  if (!showGradient) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 h-32 pointer-events-none z-40 xl:hidden">
      <div
        className="w-full h-full"
        style={{
          background:
            "linear-gradient(to top, #f2f9ff 0%, #f2f9ff 20%, rgba(242, 249, 255, 0.8) 50%, transparent 100%)",
        }}
      />
    </div>
  );
};
